// @owners { team: patients }
import rx from '~shared/assets/images/RX@2x.png';
import menopur from '~shared/assets/images/menopur@2x.png';
import progynyLogo from '~shared/assets/images/progyny_by_alto_logo@2x.png';
import rxPaperWithQuestionMark from '~shared/assets/images/rx_paper_with_question_mark@2x.png';

// Web uses the @2x assets because the web bundler serves a single resolution (no automatic @2x/@3x
// density selection like native), so the images stay crisp on retina displays. Keys must match
// progynyAssets.ts.
export const progynyAssets = {
  logo: progynyLogo,
  menopur,
  rx,
  rxPaperWithQuestionMark,
};
